import { AlertTriangle, Home, RotateCcw } from "lucide-react";
import { isRouteErrorResponse, useNavigate, useRouteError } from "react-router-dom";

export function RouteErrorPage() {
  const error = useRouteError();
  const navigate = useNavigate();
  const message = isRouteErrorResponse(error)
    ? `${error.status} ${error.statusText}`.trim()
    : error instanceof Error && error.message
      ? error.message
      : "The page could not be rendered.";
  return <div className="page narrow" role="alert"><section className="empty-state route-error"><div className="empty-icon"><AlertTriangle size={22} /></div><h1>Something went wrong</h1><p>{message}</p><p>Your saved data was not changed. Try this page again or return to Today.</p><div className="button-group"><button className="button primary" onClick={() => window.location.reload()}><RotateCcw size={15} />Try Again</button><button className="button" onClick={() => navigate("/today")}><Home size={15} />Go to Today</button></div></section></div>;
}
